<template>
  <div v-if="pagination">
    <span style="font-size:9pt">Página {{pagination.current_page}} de {{pagination.last_page}}</span>
    <el-pagination
      background
      layout="prev, pager, next"
      :page-count="pagination.last_page"
      @current-change="navigation"
      :current-page.sync="pagination.current_page"
    />
    <i style="font-size:9pt">{{pagination.total}} registro(s)</i>
  </div>
</template>

<script>

export default {
	name:"ed-paginate",
  components:{},
	mixins: [],

  props:{
    pagination:{
      type: Object,
      default: null
    },
    navigation:{
      type: Function,
      default: function(){return}
    },
  },

  watch:{
    pagination(){
    },
    navigation(){
    }
  },

	data () {
    return {
      page: 1
    }
  },

  mounted() {
  },

  methods:{

    onHandlerPage(){
      this.navigation(this.page)
    },

  }
}

</script>



// WEBPACK FOOTER //
// paginate.vue?4d3eb04b